<template>
    <simple-layout
        :models-loaded="true"
        name="Facturation"
        imgPosY="-300"
    >
        <div class="headline">
            <h1>Facturations</h1>
            <el-button type="primary" class="create-btn" @click="createBill">Créer une facture</el-button>        
        </div>
        <ns-loader
            :toLoad="[{model: 'clients', name: 'clients'}]"
            @dataFetched="onDataFetched"
        >
            <ns-paginate
                slot="content"
                baseUrl="bill/"
                :displayCsvButton="false"
                :filters="filters"
                ref="nsPaginate"
            >
                <div slot="filter" slot-scope="props">
                    <div class="blockFilter">
                        <el-row
                            :gutter="40"
                            style="width: 100%;"
                        >
                            <el-col
                                :xs="24"
                                :sm="12"
                                :md="12"
                                :lg="12"
                                :xl="12"
                            >
                                <label>Clients</label><br>
                                <el-select
                                    v-model="selectedClient"
                                    value-key="name"
                                    filterable
                                    @change="onChange"
                                >
                                    <el-option
                                        v-for="item in clientsPresentInFacturations"
                                        :key="item.uid"
                                        :label="item.name"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <div
                            class="blockFlex"
                            style="justify-content: flex-end;"
                        >
                            <el-button
                                @click="resetFilters"
                            >
                                <span>Réinitialiser filtres</span>
                            </el-button>
                            <el-button
                                type="primary"
                                @click="props.applyFilters"
                            >
                                <span>Appliquer filtres</span>
                            </el-button>
                        </div>
                    </div>
                </div>

                <template slot="custom-column">
                    <el-table-column
                        label="Client"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.client.name }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Date de début"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.start_date | moment('DD/MM/YYYY') }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Date de fin"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.end_date | moment('DD/MM/YYYY') }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Total"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.total_amount }} €
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Opérations"
                    >
                        <template slot-scope="scope">

                            <el-button type="primary" icon="el-icon-search" @click="openPreview(scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </template>

            </ns-paginate>
        </ns-loader>
        <modal-create-facturation ref="modalCreateFacturation"></modal-create-facturation>
        <el-dialog
            title="Aperçu de la facture"
            :visible.sync="previewModalOpened"
            width="60%"
            @close="previewModalOpened = false"
            append-to-body
        >
            <preview printable :billData="selectedBill" :client="clientBill"></preview>
            <span slot="footer">
                <el-button @click="previewModalOpened = false">Fermer</el-button>
            </span>
        </el-dialog>
    </simple-layout>
</template>

<script>
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import modalCreateFacturation from './modal-create-facturation.vue';
import preview from './preview.vue';

export default {

    components: {
        NsLoader,
        modalCreateFacturation,
        preview,
    },
    data (){
        return {
            previewModalOpened: false,
            selectedBill: null,
            clientBill: null,
            selectedClient: null,
            clients: [],
            paginateInfo: null,
            filters: [
                {
                    key: 'client',
                    verbose: 'Client',
                },
                {
                    key: 'start_date',
                    verbose: 'Date de début',
                },
                {
                    key: 'end_date',
                    verbose: 'Date de fin',
                }
            ],
        };
    },

    computed: {
        fetchedFilters (){
            return this.$refs.nsPaginate.fetchedFilters;
        },
        clientsPresentInFacturations (){
            return this.fetchedFilters.client.map((clientUid) => {
                return this.clients.find((client) => client.uid === clientUid);
            });
        },
    },
    methods: {
        openPreview(bill){
            this.$set(this, 'selectedBill', bill);
            this.$set(this, 'clientBill', this.clients.find(client=>bill.client_uid === client.uid));
            this.previewModalOpened = true;
        },
        createBill() {
            this.$refs.modalCreateFacturation.open();
        },
        resetFilters (){
            this.$refs.nsPaginate.filtersValue.keysFilter.client = '';
            this.$refs.nsPaginate.loadContent();
        },
        onDataFetched (response){
            this.$store.dispatch('fundation/updateArrayOfItems', {
                targetArray: response.clients,
                srcArray: this.clients,
            });
        },
        onChange (item){
            this.$refs.nsPaginate.filtersValue.keysFilter.client = item.uid;
        }
    },
};
</script>

<style lang="scss">
.headline {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Facturation/index.vue